<template lang="pug">
  .region(v-if="region && region.code")
    slot(:region="region")

</template>

<script>
  import vueColorbarSvc from '@services/vueColorbarSvc';

  export default {
    name: "Region",

    props: {
      regionCode: {
        type: String
      },
    },

    data() {
      return {
        region: null,
      };
    },

    watch: {
      regionCode: {
        async handler(value) {
          const res = await vueColorbarSvc.getRegion({
            code: value,
          });
          this.region = res.data;
        },
        immediate: true,
      }
    },
  };
</script>

<style scoped lang="stylus">
</style>
